'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumCustomer as LogoCustomer } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/customer/_list')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();

  // スコープ外のセクションタブ（顧客一覧以外）は _placeholders で ComingSoon を表示する。
  const tabs = [{
    to: '/customer/overview',
    children: t('common.list.overview')
  }, {
    to: '/customer',
    children: t('pages.customerLedger.listPageTitle'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/customer/alerts',
    children: t('common.list.alerts')
  }, {
    to: '/customer/contract-and-cost',
    children: t('common.list.contractAndCost')
  }, {
    to: '/customer/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/customer/rule-and-policy',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/customer/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoCustomer} name={t('common.list.customers')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}